import { useEffect, useState } from "react";
import { icons } from "utils/constants";
import {
  // Button, Modal,
  Roundedloader,
} from "components";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getSignatureMessage,
  handleLogin,
  // handleVerifyPassword,
} from "store/globalSlice";
import {
  getDataFromLocalStorage,
  // trimLeftSpace
} from "utils/helpers";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { useAccount } from "wagmi";
import "./Home.scss";
import DarkTheme from "pages/DarkTheme";

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reduxData = useSelector((state) => state.global);
  const { isDarkMode } = reduxData || {};
  // const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [verifyLoading, setVerifyLoading] = useState(false);
  const [immidiateLogin, setImmidiateLogin] = useState(false);
  // const [password, setPassword] = useState("");
  // const [passwordError, setPasswordError] = useState("");
  // const [passwordType, setPasswordType] = useState("password");
  const account = useAccount();
  const { address } = account;
  // Take account permission and get signature from metamask
  const handleConnect = async () => {
    setIsLoading(true);
    const ethereum = window.ethereum;
    const response = await dispatch(getSignatureMessage(address));
    if (response?.status === 403) {
      navigate("/alpha-mode");
      return;
    }
    const customMessage = response?.data?.message || "";
    try {
      const signature = await ethereum.request({
        method: "personal_sign",
        params: [customMessage, address],
      });
      const loginResponse = await dispatch(
        handleLogin({
          address: address,
          signature: signature,
          message: customMessage,
        })
      );
      if (loginResponse?.status === 201) {
        setIsLoading(false);
        // setShow(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  // const handleVerify = async () => {
  //   setVerifyLoading(true);
  //   const res = await dispatch(
  //     handleVerifyPassword({
  //       password: password,
  //     })
  //   );
  //   if (res?.status === 200) {
  //     setShow(false);
  //     setPassword("");
  //     setPasswordError("");
  //   }
  //   setVerifyLoading(false);
  // };

  useEffect(() => {
    if (address && immidiateLogin) {
      handleConnect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);

  useEffect(() => {
    if (localStorage.isAlphaMode) {
      navigate("/alpha-mode");
      localStorage.removeItem("isAlphaMode");
    } else {
      if (getDataFromLocalStorage("access_token")) {
        navigate("/dashboard");
      } else {
        // setShow(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const handleKeyPress = (e) => {
  //   if (e?.keyCode === 13 && show && password) {
  //     handleVerify();
  //   }
  // };
  // useEffect(() => {
  //   document.addEventListener("keydown", handleKeyPress);
  //   return () => document.removeEventListener("keydown", handleKeyPress);
  // });

  return (
    <div id="home-container">
      {/* {show && (
        <Modal
          title="Security Password"
          width="500px"
          onHide={() => {}}
          hideCloseButton
          isDarkMode={isDarkMode}
        >
          <div className="cpt-30 cps-26 cpe-26">
            <div
              className={`text-16-500 mb-3 ${
                isDarkMode ? "color-ffff" : "color-2749"
              }`}
            >
              Enter security password in following input for access this site
              and flow.
            </div>
            <div className="position-relative inputStyle">
              <input
                placeholder="Enter password"
                value={password}
                error={passwordError}
                type={passwordType}
                onChange={(e) => {
                  setPasswordError("");
                  setPassword(trimLeftSpace(e.target.value));
                }}
                maxLength="60"
              />
              <div
                className="t-input-icon h-16"
                onClick={() => {
                  setPasswordType(
                    passwordType === "text" ? "password" : "text"
                  );
                }}
              >
                <img
                  src={
                    passwordType === "text"
                      ? isDarkMode
                        ? icons.eyelight
                        : icons.eye
                      : isDarkMode
                      ? icons.eyeslashlight
                      : icons.eyeSlash
                  }
                  alt="eye"
                  className="fit-image"
                />
              </div>
            </div>
            <div className="d-flex justify-content-end cmt-30 cpb-10">
              <Button
                btnStyle="PD"
                btnText="Verify"
                loading={verifyLoading}
                onClick={handleVerify}
                className="cps-40 cpe-40"
                disabled={!password}
              />
            </div>
          </div>
        </Modal>
      )} */}
      <div className={` cpt-22 cpb-22 ${isDarkMode ? "bb-4d6c" : " bb-e3e3"}`}>
        <div className="fb-center container">
          <div className="h-35">
            <img
              src={isDarkMode ? icons.logoDark : icons.logo}
              alt="logo"
              className="fit-image"
            />
          </div>
          {/* {!show && ( */}
          <div className="fb-center gap-2">
            <div>
              {/* {address === "0x6b2A8385e165Ce805BfD879D2De56643b7b42135" && (
                )} */}
              <DarkTheme />
            </div>
            <div className="fa-center gap-4">
              {address ? (
                <div
                  className="f-center gap-2 b-dee3 cpt-10 cpb-10 cps-18 cpe-18 br-10 pointer"
                  onClick={handleConnect}
                >
                  <span className="h-20 d-flex">
                    <img
                      src={isDarkMode ? icons.walletDark : icons.wallet}
                      alt="wallet"
                      className="fit-image"
                    />
                  </span>
                  <span
                    className={`text-14-600  ${
                      isDarkMode ? "color-ffff" : "color-2749"
                    }`}
                  >
                    Connect wallet
                  </span>
                  {isLoading && (
                    <span
                      className={`text-14-600  ${
                        isDarkMode ? "color-ffff" : "color-2749"
                      }`}
                    >
                      <Roundedloader type={isDarkMode ? "L" : "D"} />
                    </span>
                  )}
                </div>
              ) : (
                <ConnectButton.Custom>
                  {({ openConnectModal }) => {
                    return (
                      <div
                        className="f-center gap-2 b-dee3 cpt-10 cpb-10 cps-18 cpe-18 br-10 pointer"
                        onClick={() => {
                          openConnectModal();
                          setImmidiateLogin(true);
                        }}
                      >
                        <span className="h-20 d-flex">
                          <img
                            src={isDarkMode ? icons.walletDark : icons.wallet}
                            alt="wallet"
                            className="fit-image"
                          />
                        </span>
                        <span
                          className={`text-14-600  ${
                            isDarkMode ? "color-ffff" : "color-2749"
                          }`}
                        >
                          Connect wallet
                        </span>
                        {isLoading && (
                          <span
                            className={`text-14-600  ${
                              isDarkMode ? "color-ffff" : "color-2749"
                            }`}
                          >
                            <Roundedloader type={isDarkMode ? "L" : "D"} />
                          </span>
                        )}
                      </div>
                    );
                  }}
                </ConnectButton.Custom>
              )}
            </div>
          </div>
          {/* // )} */}
        </div>
      </div>
      <div className="body-block">
        <div className="w-100" style={{ height: "450px" }}>
          <img
            src={isDarkMode ? icons.bannerDark : icons.banner}
            alt="banner"
            className="fit-image"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
